/**
 * App Badge Service
 *
 * Uses the Badging API (navigator.setAppBadge / clearAppBadge) to show
 * a count on the PWA icon (taskbar, dock, home screen).
 *
 * Gracefully no-ops when the API is not available (Firefox, non-PWA contexts).
 */

const isSupported = 'setAppBadge' in navigator

/**
 * Set the app badge to a given count.
 * @param {number} count — 0 clears the badge; >0 shows the number
 */
export async function updateBadge(count) {
  if (!isSupported) return
  try {
    if (count > 0) {
      await navigator.setAppBadge(count)
    } else {
      await navigator.clearAppBadge()
    }
  } catch (e) {
    // Some environments throw even when the API exists (e.g. insecure context)
    console.warn('App badge update failed:', e)
  }
}

/**
 * Clear the app badge entirely.
 */
export async function clearBadge() {
  if (!isSupported) return
  try {
    await navigator.clearAppBadge()
  } catch (e) {
    console.warn('App badge clear failed:', e)
  }
}
